import React from 'react';

import classNames from "classnames";
import styles from "../styles/betting-zone.drawer-menu.module.scss";
import {Image} from "../../../../../core/components/image/image";
import {LogoImageParams} from "../../../../../core/components/logo-icon/models/logo.image-params";

export const BettingZoneDrawerMenuMainLogo = (() => {
  const logoProps = {
    className: classNames(styles.main_logo),
    src: new LogoImageParams(null, 60, 32)
  }

  return (
    <div className={classNames(styles.main_logo_container)}>
      <Image {...logoProps}/>
    </div>
  )
});
